// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__206Ht","row":"styles_row__4aXba"};